import { render, staticRenderFns } from "./internbudgetaddfrm.vue?vue&type=template&id=3aa5a4af"
import script from "./internbudgetaddfrm.vue?vue&type=script&lang=js"
export * from "./internbudgetaddfrm.vue?vue&type=script&lang=js"
import style0 from "./internbudgetaddfrm.vue?vue&type=style&index=0&id=3aa5a4af&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports